// extracted by mini-css-extract-plugin
export var plasmic_tokens = "plasmic_36_dot_22-module--plasmic_tokens---Z8at";
export var global_mode_dark = "plasmic_36_dot_22-module--global_mode_dark--x-CrG";
export var plasmic_default_styles = "plasmic_36_dot_22-module--plasmic_default_styles--LOHNp";
export var all = "plasmic_36_dot_22-module--all--z2kd6";
export var img = "plasmic_36_dot_22-module--img--NLIvq";
export var li = "plasmic_36_dot_22-module--li--T8MUF";
export var span = "plasmic_36_dot_22-module--span--gQCl9";
export var input = "plasmic_36_dot_22-module--input--Ov2rc";
export var textarea = "plasmic_36_dot_22-module--textarea--X-Nsr";
export var button = "plasmic_36_dot_22-module--button--pi4Ha";
export var code = "plasmic_36_dot_22-module--code--NjDXW";
export var pre = "plasmic_36_dot_22-module--pre--dDv8H";
export var p = "plasmic_36_dot_22-module--p--btWO3";
export var h1 = "plasmic_36_dot_22-module--h1--ScfnC";
export var h2 = "plasmic_36_dot_22-module--h2--n+zfp";
export var h3 = "plasmic_36_dot_22-module--h3---i2DD";
export var h4 = "plasmic_36_dot_22-module--h4--jMh9k";
export var h5 = "plasmic_36_dot_22-module--h5--Tqyhb";
export var h6 = "plasmic_36_dot_22-module--h6--qmJa6";
export var address = "plasmic_36_dot_22-module--address--7zwqs";
export var a = "plasmic_36_dot_22-module--a--std0Z";
export var ol = "plasmic_36_dot_22-module--ol--py-g0";
export var ul = "plasmic_36_dot_22-module--ul--qDUov";
export var select = "plasmic_36_dot_22-module--select--hrdck";
export var plasmic_default__component_wrapper = "plasmic_36_dot_22-module--plasmic_default__component_wrapper--DhG7t";
export var plasmic_default__inline = "plasmic_36_dot_22-module--plasmic_default__inline--8L2To";
export var plasmic_page_wrapper = "plasmic_36_dot_22-module--plasmic_page_wrapper--GhQJz";
export var root_reset = "plasmic_36_dot_22-module--root_reset--t101J";
export var plasmic_default__h4 = "plasmic_36_dot_22-module--plasmic_default__h4--Ofm0Z";
export var plasmic_default__h5 = "plasmic_36_dot_22-module--plasmic_default__h5--IDEy3";
export var plasmic_default__h6 = "plasmic_36_dot_22-module--plasmic_default__h6--Bxt-E";
export var plasmic_default__a = "plasmic_36_dot_22-module--plasmic_default__a--dRbne";
export var plasmic_default__blockquote = "plasmic_36_dot_22-module--plasmic_default__blockquote--P2pQH";
export var blockquote = "plasmic_36_dot_22-module--blockquote--8LN+g";
export var plasmic_default__h1 = "plasmic_36_dot_22-module--plasmic_default__h1--CtV6D";
export var plasmic_default__h2 = "plasmic_36_dot_22-module--plasmic_default__h2--nKMAQ";
export var plasmic_default__h3 = "plasmic_36_dot_22-module--plasmic_default__h3--HVEyf";
export var plasmic_default__code = "plasmic_36_dot_22-module--plasmic_default__code--ZYdct";
export var plasmic_default__pre = "plasmic_36_dot_22-module--plasmic_default__pre--5E8HP";
export var plasmic_default__ol = "plasmic_36_dot_22-module--plasmic_default__ol--tOCMo";
export var plasmic_default__ul = "plasmic_36_dot_22-module--plasmic_default__ul--d3Rxw";